import { CROSS_BASKET_BLOCK } from "../models/_consts";
import { openModal } from "../features/dashBoard/dashboardSlice";
import { useAppDispatch, useAppSelector } from "../store/configureStore";

// Promo basket and instore basket are mutually exclusive. This hook returns
// guards that block an action and open the cross-basket modal when the other
// basket type is currently in use.
export default function useBasketGate() {
  const dispatch = useAppDispatch();
  const { basket } = useAppSelector((state) => state.basket);
  const instoreItems = useAppSelector((state) => state.instoreBasket.items);

  const promoActive = !!basket;
  const instoreActive = instoreItems.length > 0;

  const block = () => dispatch(openModal(CROSS_BASKET_BLOCK));

  return {
    promoActive,
    instoreActive,
    // Run `action` unless the instore basket is in use.
    guardPromoAction: <Args extends unknown[]>(
      action: (...args: Args) => void
    ) =>
      (...args: Args) => {
        if (instoreActive) {
          block();
          return;
        }
        action(...args);
      },
    // Run `action` unless the promo basket is in use.
    guardInstoreAction: <Args extends unknown[]>(
      action: (...args: Args) => void
    ) =>
      (...args: Args) => {
        if (promoActive) {
          block();
          return;
        }
        action(...args);
      },
  };
}
